import { EPermissoes } from '@/enums/ePermissoes';
import { routes as cabos } from './cabos';
import { routes as ceramica } from './ceramica';

export default [
  {
    path: '/utilidade',
    name: 'utilidadedefault',
    description: 'Utilidade',
    icon: 'uil-screw',
    children: [
      {
        path: '',
        name: 'utilidadedefault-index',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'utilidade',
        description: 'Dashboard',
        component: () => import('@/views/utilidade/Index.vue'),
        meta: {
          utlTipoFornecimentoId: [206, 101],
          opcoesTipoFornecimento: { 206: 'Cabos', 101: 'Cerâmica' },
          permissions: [EPermissoes.Relatorio]
        },
        goesToMenu: true
      },
      {
        path: 'relatorios',
        name: 'utilidaderelatorios',
        description: 'Relatórios',
        component: () => import('@/views/utilidade/Relatorios.vue'),
        meta: {
          utlTipoFornecimentoId: [206, 101],
          opcoesTipoFornecimento: { 206: 'Cabos', 101: 'Cerâmica' },
          permissions: [EPermissoes.Relatorio]
        },
        goesToMenu: true
      },
      ...cabos,
      ...ceramica
    ],
    customChildren: ['Cerâmica', 'Cabos']
  }
];
